import { Link } from 'gatsby';
import React, { ReactElement } from 'react';

import './link.text.scss';

interface LinkProps {
    to: string;
    weight?: 'light';
    color: 'red' | 'yellow' | 'green' | 'blue' | 'orange' | 'magenta' | 'violet' | 'purple' | 'pink';
    children: ReactElement;
    type?: 'primary' | 'secondary' | 'tertiary';
    addClass?: string;
    external?: boolean;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => boolean
}

function LinkText({ to, color, children, weight, type, addClass, external, onClick }: LinkProps) {

    const isExternal = external || to.includes('http');
    const handleClick = (onClick: (e: React.MouseEvent<HTMLAnchorElement>) => boolean) => (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Click Wrapper intended to be used with Google Analytics & other trackers
        // >> Makes sure that the onClick function is called before the click event is registered
        console.log('handleCLick Event', e)
        onClick(e)
        return true
    }

    if (isExternal && !onClick) {
        return (
            <a
                className={`text ${color} ${!!type ? type : ''} ${weight ? weight : ''} ${!!addClass ? addClass : ''}`}
                href={to}>
                {children}
            </a>
        )
    } else if (isExternal && onClick) {
        return (
            <a
                onClick={handleClick(onClick)}
                className={`text ${color} ${!!type ? type : ''} ${weight ? weight : ''} ${!!addClass ? addClass : ''}`}
                href={to}>
                {children}
            </a>
        )
    }
    return (
        <Link
            className={`text ${color} ${!!type ? type : ''} ${weight ? weight : ''} ${!!addClass ? addClass : ''}`}
            onClick={onClick ? onClick : () => true}
            to={to}>
            {children}
        </Link>
    )
}

export default LinkText;